import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import LoadingSkeleton from "../../../../loader/TableLoader";
import Pagination from "../../../../commanPage/pagination/Pagination";
import { NoItemsLeftInTable } from "../../../../../helpers/helpers";

function OfferListTable({ offers, loading, auctionType }) {
  const totalNumberRow = 20;
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [currentPage, setCurrentPage] = useState(0);
  const navigate = useNavigate();

  return (
    <div className="flex column full-width mt-1">
      {loading ? (
        <div className="valign-wrapper justify-center cover white">
          <LoadingSkeleton
            headerData={[
              "Lots Id",
              "Product Type",
              "Quantity / UOM",
              "EMD Amount (Rs.)",
              "Starting price (Rs.)",
              "Min Increment(Rs.)",
              "Action",
            ]}
          />
        </div>
      ) : (
        <>
          <div
            className={`${
              !isTablet && "table-container-style"
            } mb-1 full-width`}
          >
            <table
              className={`responsive-table centered ${
                isTablet ? "auction_table table-style" : "custom-table-style"
              } `}
            >
              <thead>
                <tr>
                  <th>Lots No.</th>
                  <th>Product Type</th>
                  <th>Quantity / UOM</th>
                  <th>EMD Amount (Rs.)</th>
                  <th>Starting price (Rs.)</th>
                  <th>Min Increment(Rs.)</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {offers
                  ?.slice(currentPage, currentPage + totalNumberRow)
                  ?.map((items, index) => (
                    <tr key={items?._id}>
                      <td>{index + 1}</td>
                      <td style={{ width: !isTablet && "230px" }}>
                        <span
                          className="NoOfline"
                          style={{ WebkitLineClamp: 1 }}
                        >
                          {items?.scrapDetails?.type}
                        </span>
                      </td>
                      <td>
                        {" "}
                        {items?.scrapDetails?.quantity}/
                        {items?.scrapDetails?.unit}
                      </td>
                      <td>{items?.EMDAmount}</td>
                      <td>
                        {items?.startingPrice > 0
                          ? items?.startingPrice
                          : "N/A"}
                      </td>
                      <td>
                        {items?.minimumBid}
                      </td>

                      <td>
                        <button
                          className="cercle-purple-text text-decoration-underLine pointer"
                          onClick={() =>
                            navigate(
                              `/forward-auction/singleOffer/${items.auction}/${items._id}`
                            )
                          }
                        >
                          View EMD
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          {offers?.length === 0 && <NoItemsLeftInTable />}
          {offers?.length > 20 && (
            <Pagination
              Data={offers}
              totalNumberRow={totalNumberRow}
              setCurrentPage={setCurrentPage}
            />
          )}
        </>
      )}
    </div>
  );
}

export default OfferListTable;
